
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/inspiration/inspirationtypes",
      function () {
        return require("private-next-pages/india/inspiration/inspirationtypes.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india/inspiration/inspirationtypes"])
      });
    }
  